<template>
    <div class="page" style="padding:12px">
        <div class="top">
          <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
          <el-button size="medium" type="primary" @click="submitFunc()">提交</el-button>
        </div>
        <div style="width: 810px;padding-top:20px;margin: 0 auto;">
            <el-form :model="formData" ref="form" label-width="140px" class="demo-ruleForm">
                <el-form-item label="客服负责人">
                    <address-book v-model="formData.addressJson" :config="addressConfig"></address-book>
                </el-form-item>
                <el-form-item label="客户经理">
                    <address-book v-model="formData.addressJsonCustomer" :config="addressConfig"></address-book>
                </el-form-item>
                <el-form-item label="是否新家校模式">
                    <el-checkbox v-model="formData.externalContact"></el-checkbox>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {updateSchoolLiable, queryLiableList} from '@/api/schoolManage';
    import BackTool from '@/components/BackTool';
    import AddressBook from '@/components/AddressBook/indexExpand';

    export default {
        name: 'schoolAdmin',
        components: {BackTool, AddressBook},
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                formData: {
                    addressJson: {
                        userJson: []
                    },
                    addressJsonCustomer: {
                        userJson: []
                    },
                    externalContact: this.$route.query.isExternalContact == 2
                },
                addressConfig: {
                    title: '选择负责人',
                    depart: {target: 'user', departType: 't', userTypes: '1'},
                    SingleChose: false
                },
            }
        },
        created() {
            queryLiableList({
                schoolId: this.schoolId,
                type: 1
            })
                .then(data => {
                    this.formData.addressJson = {
                        userJson: data
                    }
                });
            queryLiableList({
                schoolId: this.schoolId,
                type: 2
            })
                .then(data => {
                    this.formData.addressJsonCustomer = {
                        userJson: data
                    }
                });
        },
        methods: {
            submitFunc() {
                const args = {
                    chooseManagerIds: this.formData.addressJson.userJson && this.formData.addressJson.userJson.length !== 0 ? this.formData.addressJson.userJson.map(item => item.id).join(',') : '',
                    custumerManagerIds: this.formData.addressJsonCustomer.userJson && this.formData.addressJsonCustomer.userJson.length !== 0 ? this.formData.addressJsonCustomer.userJson.map(item => item.id).join(',') : '',
                    confirm: false,
                    externalContact: this.formData.externalContact ? 2 : 1,
                    schoolId: this.schoolId
                };
                updateSchoolLiable(args)
                    .then(res => res.data)
                    .then(data => {
                        if (data.result) {
                            this.$message.success('设置成功');
                            setTimeout(() => {
                                this.$router.back();
                            }, 200);
                        } else if (data.code === 1005) {
                            this.$confirm(data.msg, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                                lockScroll: false
                            }).then(() => {
                                args.confirm = true;
                                updateSchoolLiable(args)
                                    .then(res => res.data)
                                    .then(data => {
                                        if (data.result) {
                                            this.$message.success('设置成功');
                                            setTimeout(() => {
                                                this.$router.back();
                                            }, 200);
                                        } else {
                                            this.$message(data.msg);
                                        }
                                    });
                            });
                        } else {
                            this.$message(data.msg);
                        }
                    })
            }
        }

    }
</script>

<style scoped>
 .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolAdmin.vue